import React from "react"
import { ISearchValue, SearchTypeEnum } from "../../../../../components/YhPageHeader/Types";
import { YhPageHeader } from "../../../../../components/YhPageHeader";
import { useOrganizationModel } from "../organizationModel"

export function SearchForm() {
    const {
        searchParam,
        upDataSearchParam,
        resetSearchParam,
        loadData
    } = useOrganizationModel();
    const searchFields = [
        {
            type: SearchTypeEnum.Input,
            span: 4,
            placeholder: "机构名称",
            fieldName: "name",
            size: "small",
            disabled: false,
        },
        {
            type: SearchTypeEnum.Select,
            span: 4,
            placeholder: "状态",
            fieldName: "enable",
            size: "small",
            disabled: false,
            options:[{key:"0",label:"关闭",value:"0"},{key:"1",label:"开启",value:"1"}]
        }    
    ]
    return (
        <YhPageHeader
            title="组织机构列表"
            searchValues={searchParam as ISearchValue}
            searchFields={searchFields}
            onChange={upDataSearchParam}
            handleSearch={loadData}
            handleReset={resetSearchParam}
        />
    )
}